import React, { useCallback } from 'react';
import { TabPanel, Item } from 'devextreme-react/tab-panel';
import UsedLeaveTab from './used-leaves-tab.tsx';
import EarnedLeaveTab from './earned-leaves-tab.tsx';

interface DetailTabPanelProps {
    employeeId: number;
    leaveInfoId: number;
}

const DetailTabPanel: React.FC<DetailTabPanelProps> = ({ employeeId, leaveInfoId }) => {
    const renderUsedLeaveTab = useCallback(() => (
        <UsedLeaveTab
            employeeId={employeeId}
            leaveInfoId={leaveInfoId}
        />
    ), [employeeId, leaveInfoId]);

    const renderEarnedLeaveTab = useCallback(() => (
        <EarnedLeaveTab
            employeeId={employeeId}
            leaveInfoId={leaveInfoId}
        />
    ), [employeeId, leaveInfoId]);

    return (
        <TabPanel>
            <Item
                title="Hak Edilmiş İzinler"
                render={renderEarnedLeaveTab}
            />
            <Item
                title="İzinler"
                render={renderUsedLeaveTab}
            />
        </TabPanel>
    );
};

export default DetailTabPanel;